import { render, staticRenderFns } from "./PlateGroups.vue?vue&type=template&id=54fe8c6d&scoped=true"
import script from "./PlateGroups.vue?vue&type=script&lang=js"
export * from "./PlateGroups.vue?vue&type=script&lang=js"
import style0 from "./PlateGroups.vue?vue&type=style&index=0&id=54fe8c6d&prod&lang=less"
import style1 from "./PlateGroups.vue?vue&type=style&index=1&id=54fe8c6d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fe8c6d",
  null
  
)

export default component.exports